<template>
  <div class="user-form">
    <return-button class="mb-4" @click="$emit('close')"></return-button>
    <form-group v-if="mode === 'edit'" label="Удалить" class="mb-4">
      <delete-button type="button" @click="$emit('archive', user)"></delete-button>
    </form-group>
    <form @submit.prevent="$emit(mode, user)">
      <div class="flex-sb-adaptive">
        <form-group label="Имя" class="mb-4">
          <custom-input type="text" v-model="user.firstName" required />
        </form-group>
        <form-group label="Фамилия" class="mb-4">
          <custom-input type="text" v-model="user.lastName" required />
        </form-group>
      </div>
      <div class="flex-sb-adaptive">
        <form-group label="Роль" class="mb-4">
          <custom-select type="text" v-model="user.role"
                         :options="Object.keys(roles).map(key => ({ label: roles[key], value: key }))"
                         required />
        </form-group>
        <form-group label="Логин" class="mb-4">
          <custom-input type="text" v-model="user.login" required :disabled="mode === 'edit'" />
        </form-group>
        <form-group :label="passwordTitle" class="mb-4">
          <custom-input type="password" v-model="user.password" :required="mode === 'add'" />
        </form-group>
      </div>
      <r-button type="submit">{{buttonTitle}}</r-button>
    </form>
  </div>
</template>

<script>
  import ReturnButton from './UIComponents/ReturnButton';
  import RButton from './UIComponents/RButton';
  import Select2 from './UIComponents/Select2';
  import roles from './../helpers/roles';
  import FormGroup from './UIComponents/FormGroup';
  import CustomInput from './UIComponents/CustomInput';
  import CustomSelect from './UIComponents/CustomSelect';
  import deleteButton from './UIComponents/DeleteButton';

  export default {
    components: {
      ReturnButton,
      RButton,
      Select2,
      FormGroup,
      CustomInput,
      CustomSelect,
      deleteButton
    },
    props: {
      user: Object,
      mode: String
    },
    data() {
      return {
        roles
      }
    },
    computed: {
      passwordTitle: function () {
        return this.mode === 'add' ? 'Пароль' : 'Новый пароль (опц.)'
      },
      buttonTitle: function () {
        return this.mode === 'add' ? 'Добавить' : 'Сохранить'
      }
    }
  }
</script>

<style scoped>
.user-form {
  max-width: 900px;
  margin: 0 auto;
}
</style>
